import { useEffect } from "react";

// Shown when a page's data request failed after retries but this exact URL
// was prerendered: re-show the first-response content (#__ssr_body__)
// instead of replacing it with a generic error screen.
export function PrerenderFallback({ el, testid }) {
  useEffect(() => {
    el.style.display = "";
    el.removeAttribute("data-hydrated");
    return () => { el.style.display = "none"; };
  }, [el]);
  return <span hidden data-testid={testid} />;
}
